import {PageBase} from "@/components/pageBase/pageBase";
import {makeStyles} from "tss-react/mui";
import {useContext} from "react";
import {Box} from "@mui/material";
import {PageTitle} from "@/components/pageBase/pageTitle";
import {AnnouncementContext} from "@/contexts/announcementContext";
import {useSSTranslation} from "@/i18n/useSSTranslation";
import {Announcements} from "@/pages/TrainingFeedPage/Announcements/Announcements";

const useStyles = makeStyles()(() => ({
	pageBase: {
		"& [class*='menuIcon']": {
			display: "none"
		}
	},
	tapToLoadBtn: {},
	container:{
		padding: "15px"

	}
}));


export const HomePage: React.FC = () => {
	const {classes} = useStyles();
	const yesterday = new Date();
	yesterday.setDate(yesterday.getDate() - 1)
	yesterday.setHours(0, 0, 0, 0)
	const {announcementState} = useContext(AnnouncementContext)
	const {t} = useSSTranslation();

	const hasAnnouncements = (announcementState?.length ?? 0) > 0;

	return (
		<PageBase
			className={classes.pageBase}
			disableSideBar
			contentWidth="1420px"
			data-test-id="home-page"
		>
			<PageTitle
				sx={{margin: "0 0 0 10px"}}
				enableDayStreak
				title={t("page_home", "Home")}
				data-test-id="home-page-title"
			/>
			<Box
				className={classes.container}
				data-test-id="home-content-container"
				role="main"
				aria-label="Home content"
			>
				{hasAnnouncements && <Announcements
					data={announcementState}
					data-test-id="home-announcements"
				/>}
			</Box>
		</PageBase>
	);
}